import useMyInfo from '@api/hooks/auth/useMyInfo';
import {
  getIsSubscribedToPlus,
  getIsSubscribedToIconic
} from '@api/selectors/subscription';

export const getIsPlusIconicSubscribedForGoal = (myInfo, goalUID = '') =>
  getIsSubscribedToPlus(goalUID)(myInfo) ||
  getIsSubscribedToIconic(goalUID)(myInfo);

const usePlusIconicSubscribed = ({ goalUID = '' }) => {
  const isPlusSubscribed = useMyInfo(getIsSubscribedToPlus(goalUID));
  const isIconicSubscribed = useMyInfo(getIsSubscribedToIconic(goalUID));

  return isPlusSubscribed || isIconicSubscribed;
};
export default usePlusIconicSubscribed;
